var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderAppdownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "header-appdownload-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-set\\u6700\\u65B0\\u6574\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "images/h5/icon-set/index-theme-icon",
    transform: "translate(-39.000000, -211.000000)",
    fill: "#feb70c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-appdownload-icon",
    transform: "translate(39.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,17.8 L2.6,17.8 C1.2,17.8 8.8817842e-16,16.6 8.8817842e-16,15.2 L8.8817842e-16,14.2 L8.8817842e-16,2.6 C8.8817842e-16,1.2 1.2,0 2.6,0 L5.4,0 C5.7,0 6,0.2 6,0.5 C6,0.5 6,0.5 6,0.6 C6,0.9 5.8,1.2 5.4,1.2 L5.4,1.2 L2.6,1.2 C1.8,1.2 1.2,1.8 1.2,2.6 L1.2,2.6 L1.2,15.2 C1.2,16 1.8,16.6 2.6,16.6 L2.6,16.6 L13.2,16.6 C14,16.6 14.6,16 14.6,15.2 L14.6,2.6 C14.6,1.8 14,1.2 13.2,1.2 L10.4,1.2 C10,1.2 9.8,0.9 9.8,0.6 L9.8,0.6 C9.8,0.3 10,0 10.4,0 L13.2,0 C14.6,0 15.8,1.2 15.8,2.6 L15.8,15.2 C15.7,16.5 14.6,17.8 13.2,17.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,12 L0.6,12 C0.3,12 4.30211422e-16,11.7 0.1,11.3 C0.1,11 0.3,10.8 0.6,10.8 L15.2,10.8 C15.5,10.8 15.8,11.1 15.7,11.5 C15.6,11.8 15.4,12 15.1,12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.9,
    cy: 14.3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,7.7 C7.6,7.7 7.3,7.4 7.3,7.1 L7.3,0.6 C7.3,0.3 7.5,4.4408921e-16 7.9,4.4408921e-16 C8.2,4.4408921e-16 8.5,0.3 8.5,0.6 L8.5,7.1 C8.4,7.5 8.2,7.7 7.9,7.7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,7.7 C7.8,7.7 7.7,7.7 7.6,7.6 L5.3,5.9 C5.1,5.7 5,5.3 5.2,5.1 C5.4,4.9 5.8,4.8 6,5 L8.2,6.6 C8.5,6.8 8.5,7.2 8.3,7.4 C8.2,7.6 8,7.7 7.9,7.7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,7.7 C7.7,7.7 7.5,7.6 7.4,7.5 C7.2,7.2 7.2,6.8 7.5,6.6 L7.5,6.6 L9.7,5 C10,4.8 10.3,4.9 10.5,5.1 C10.7,5.4 10.6,5.7 10.4,5.9 L8.2,7.6 C8.1,7.6 8,7.7 7.9,7.7 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAppdownloadIcon);
export default __webpack_public_path__ + "static/media/header-appdownload-icon.77aa15d16f74eaaa384902788a64eec7.svg";
export { ForwardRef as ReactComponent };